export type IDataNotaFiscalEntrada = {
    id: number;
    numero_nota: string;
    serie_nota: string;
    chave:string;
    valor_total: number;
    tipo_emissor: string | null;
    codigo_emissor: string | null;
    nome_emissor: string | null;
    tipo_destinatario: string | null;
    codigo_destinatario: string | null;
    nome_destinatario: string | null;
    natureza_operacao: string;
    data_emissao: string
    status: string
    cnpj_emissor: string | null;
    endereco_emissor: TEnderecoEmissor | null;
}

export const notaFiscalEntradaDefValue: IDataNotaFiscalEntrada = {
    id: 0,
    numero_nota: "",
    serie_nota: "",
    valor_total: 0,
    chave: "",
    tipo_emissor: "",
    codigo_emissor: "",
    nome_emissor: "",
    tipo_destinatario: "",
    codigo_destinatario: "",
    nome_destinatario: "",
    cnpj_emissor: "",
    endereco_emissor: null,
    natureza_operacao: "",
    data_emissao: "",
    status: ""
}

type TEnderecoEmissor = {
    logradouro: string;
    numero: string;
    complemento: string;
    bairro: string;
    municipio: string;
    uf: string;
    cep: string;
    codigo_municipio: string;
    pais: string;
    codigo_pais: string;
    fone: string;
}